import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken } from '../../GlobalStateContainer/actions'
import $ from 'jquery'

const EMULATION_MODE_SURVEYS = false


/*
 * Survey Actions
 * 
 */

export function fetchSurveysList(surveys) {
    let cmd = 'FETCH_SURVEYS_LIST'

    if (EMULATION_ALL || EMULATION_MODE_SURVEYS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: [
                        {
                            productBrickId: 1,
                            name: 'Species',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMDEX',
                            example: 'Oak'
                        },
                        {
                            productBrickId: 2,
                            name: 'Brand Name',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMMFG',
                            example: 'Bal'
                        },
                        {
                            productBrickId: 3,
                            name: 'Edge',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'Rounded',
                            example: 'Rounded'
                        }
                    ]
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd,
                    payload: {
                        data: surveys
                    }
                }
            )

            axios.post(buildRequestUrl('Surveys/AverageScores'), JSON.stringify(surveys), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchSurveyError(dispatch) {

    dispatch(
        {
            type: 'FETCH_SURVEY_ERROR',
        }
    )
}

export function fetchSurvey(survey) {
    let cmd = 'FETCH_SURVEY'

    if (EMULATION_ALL || EMULATION_MODE_SURVEYS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('Surveys/SurveysByCategories'), JSON.stringify(survey), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorSurvey(dispatch) {

    dispatch(
        {
            type: 'SURVEY_ERROR',
        }
    )
}

export function fetchSurveyDetail(survey) {
    let cmd = 'FETCH_SURVEY_DETAIL'

    if (EMULATION_ALL || EMULATION_MODE_SURVEYS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('Surveys/SurveyByIndividualCustomer'), JSON.stringify(survey), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorSurveyDetail(dispatch) {

    dispatch(
        {
            type: 'SURVEY_DETAIL_ERROR',
        }
    )
}

export function export_excel_surveys(dispatch, filter) {
    $('#product-surveys *').prop('disabled', true);
    let cmd = 'FETCH_SURVEYS';
    let done = true;
    execWithApiToken(dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd,
                payload: {
                    data: {
                        page: filter && filter.pageIndex ? filter.pageIndex : 1
                    }
                }
            });

        var stringify = {};
        stringify.startDate = filter.startDate;
        stringify.endDate = filter.endDate;
        stringify.reportingCategory = filter.reportingCategory;
        stringify.selectedReportingCategory = filter.selectedReportingCategory;
        if (filter.surveyType !== null) {
            stringify.surveyType = filter.surveyType;
        }
        dispatch(
            {
                type: 'EXPORT_START_SURVEYS',
                payload: {
                    data: false
                }
            }
        )

        let percComplete = 0;
        dispatch(
            {
                type: 'PERCENTAGE_COMPLETE_SURVEYS',
                payload: {
                    data: percComplete
                }
            }
        )

        document.getElementById("startExport").style.display = "inline";

        axios.post(buildRequestUrl('Surveys/SurveysByExport'), JSON.stringify(stringify),
            {
                responseType: 'blob', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
                onDownloadProgress: progressEvent => {

                    dispatch(
                        {
                            type: 'FINISH_EXPORT_SURVEYS',
                            payload: {
                                data: percComplete
                            }


                        }
                    )

                    dispatch(
                        {
                            type: 'COMPLETE_EXPORT_SURVEYS',
                            payload: {
                                data: true
                            }


                        }
                    )


                }
            })
            .then((resp) => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Surveys_Export.xlsx');
                document.body.appendChild(link);
                link.click();
                $('#product-surveys *').prop('disabled', false);
                dispatch(
                    {
                        type: 'COMPLETE_EXPORT_SURVEYS',
                        payload: {
                            data: false
                        }


                    }
                )

                setTimeout("document.getElementById('startExport').style.display = 'none';", 1000);

            })
            .catch((err) => {
                //TODO:
                alert(err);
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })


    })

}

export function export_excel_individual_survey(dispatch, filter) {
    $('#detailsurvey *').prop('disabled', true);
    let cmd = 'FETCH_SURVEY_DETAIL';
    let done = true;
    execWithApiToken(dispatch, cmd, (dispatch, token) => {
        

        var stringify = {};
        stringify.susurvey = filter.susurvey;
        dispatch(
            {
                type: 'EXPORT_START_SURVEY_DETAIL',
                payload: {
                    data: false
                }
            }
        )

        let percComplete = 0;
        dispatch(
            {
                type: 'PERCENTAGE_COMPLETE_SURVEY_DETAIL',
                payload: {
                    data: percComplete
                }
            }
        )

        document.getElementById("startExportDetail").style.display = "inline";
       axios.post(buildRequestUrl('Surveys/SurveyByIndividualCustomerExport'), JSON.stringify(stringify),
            {
                responseType: 'blob', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
                onDownloadProgress: progressEvent => {
                    dispatch(
                        {
                            type: 'FINISH_EXPORT_SURVEY_DETAIL',
                            payload: {
                                data: percComplete
                            }


                        }
                    )
                   dispatch(
                        {
                            type: 'COMPLETE_EXPORT_SURVEY_DETAIL',
                            payload: {
                                data: true
                            }


                        }
                    )

                }
            })
            .then((resp) => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Individual_Survey.pdf');
                document.body.appendChild(link);
                link.click();
                $('#detailsurvey *').prop('disabled', false);
                dispatch(
                    {
                        type: 'COMPLETE_EXPORT_SURVEY_DETAIL',
                        payload: {
                            data: false
                         }


                    }
                )
                setTimeout("document.getElementById('startExportDetail').style.display = 'none';", 1000);

            })
            .catch((err) => {
                //TODO:
                alert(err);
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
               )
            })

        axios.post(buildRequestUrl('Surveys/SurveyByIndividualCustomer'), JSON.stringify(filter), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: resp
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })

}